import { useNavigate } from 'react-router-dom';
import { usePlatformAdmin } from '../admin/usePlatformAdmin';
import { useDevMode } from './DevModeProvider';

/**
 * Sidebar "Enter Dev Mode" action for platform admins. Lives under devmode/**
 * (i18n-exempt, staff-only) so its English label doesn't need a catalog key.
 * Renders nothing for non-admins. Enables Dev Mode and routes to the hub.
 *
 * `onNavigate` lets the host shell close its mobile nav drawer after the click.
 */
export function DevModeSidebarEntry({ onNavigate }: { onNavigate?: () => void }) {
  const adminQ = usePlatformAdmin();
  const { enable } = useDevMode();
  const navigate = useNavigate();

  if (adminQ.data !== true) return null;

  return (
    <button
      type="button"
      onClick={() => {
        enable();
        navigate('/dev');
        onNavigate?.();
      }}
      className="py-2 text-left text-sm text-muted hover:text-ink"
    >
      Enter Dev Mode
    </button>
  );
}
